<script setup lang="ts">
defineProps<{
  title: string
  items?: {
    link: StoryBlokLink
    title: string
  }[]
}>()

const open = ref(false)
</script>

<template>
  <div class="px-2.5 py-2 lg:py-5 lg:w-232px">
    <div class="flex justify-between items-center" @click="open = !open">
      <h5 v-html="title" />
      <AppIcon size="24" :class="{ 'rotate-180': open }" class="transform duration-200 lg:hidden" icon="far-angle-down" />
    </div>
    <div :class="{ hidden: !open }" class="flex flex-col mt-3 gap-2.5 lg:flex">
      <StoryblokLink v-for="item in items" class="hover:underline text-sm" v-bind="item.link">
        {{ item.title }}
      </StoryblokLink>
    </div>
  </div>
</template>
